module.exports = __webpack_public_path__ + "img/yenSign.50c51e23.svg";